export default function IconNotesPaperText({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M30.1333 2.56163V19.735H21.5466C21.2213 19.735 20.9092 19.8643 20.6792 20.0943C20.4492 20.3243 20.3199 20.6363 20.3199 20.9616V29.5483H3.14659C2.82125 29.5483 2.50925 29.419 2.2792 29.189C2.04916 28.959 1.91992 28.6469 1.91992 28.3216V2.56163C1.91992 2.23629 2.04916 1.92429 2.2792 1.69424C2.50925 1.4642 2.82125 1.33496 3.14659 1.33496H28.9066C29.2319 1.33496 29.544 1.4642 29.774 1.69424C30.004 1.92429 30.1333 2.23629 30.1333 2.56163Z"
        fill="#FFEF5E"
      />
      <path
        d="M30.1336 19.7354L20.3203 29.5487V20.962C20.3203 20.6367 20.4496 20.3246 20.6796 20.0946C20.9096 19.8646 21.2217 19.7354 21.547 19.7354H30.1336Z"
        fill="#FFBC44"
      />
      <path
        d="M30.1333 2.56163V19.735H21.5466C21.2213 19.735 20.9092 19.8643 20.6792 20.0943C20.4492 20.3243 20.3199 20.6363 20.3199 20.9616V29.5483H3.14659C2.82125 29.5483 2.50925 29.419 2.2792 29.189C2.04916 28.959 1.91992 28.6469 1.91992 28.3216V2.56163C1.91992 2.23629 2.04916 1.92429 2.2792 1.69424C2.50925 1.4642 2.82125 1.33496 3.14659 1.33496H28.9066C29.2319 1.33496 29.544 1.4642 29.774 1.69424C30.004 1.92429 30.1333 2.23629 30.1333 2.56163Z"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.1336 19.7354L20.3203 29.5487V20.962C20.3203 20.6367 20.4496 20.3246 20.6796 20.0946C20.9096 19.8646 21.2217 19.7354 21.547 19.7354H30.1336Z"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.43945 12.9338L8.66612 11.7071C8.99158 11.382 9.43277 11.1994 9.89279 11.1994C10.3528 11.1994 10.794 11.382 11.1195 11.7071C11.4449 12.0322 11.8861 12.2148 12.3461 12.2148C12.8061 12.2148 13.2473 12.0322 13.5728 11.7071C13.8982 11.382 14.3395 11.1994 14.7995 11.1994C15.2595 11.1994 15.7007 11.382 16.0261 11.7071C16.3516 12.0322 16.7928 12.2148 17.2528 12.2148C17.7128 12.2148 18.154 12.0322 18.4795 11.7071C18.8049 11.382 19.2461 11.1994 19.7061 11.1994C20.1661 11.1994 20.6074 11.382 20.9328 11.7071C21.2582 12.0322 21.6995 12.2148 22.1595 12.2148C22.6195 12.2148 23.0607 12.0322 23.3861 11.7071L24.6128 10.4805"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.43945 19.0664L8.66612 17.8397C8.99158 17.5147 9.43277 17.332 9.89279 17.332C10.3528 17.332 10.794 17.5147 11.1195 17.8397C11.4449 18.1648 11.8861 18.3475 12.3461 18.3475C12.8061 18.3475 13.2473 18.1648 13.5728 17.8397"
        stroke="#191919"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
